import Warning from './Warning';
import Error from './Error';
import Success from './Success';
import Info from './Info';
import Helper from './Helper';

export default {
  Warning,
  Error,
  Success,
  Info,
  Helper,
};

export const WarningInlineFeedback = Warning;
export const ErrorInlineFeedback = Error;
export const SuccessInlineFeedback = Success;
export const InfoInlineFeedback = Info;
export const HelperInlineFeedback = Helper;
